/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Annotation from 'solis/claude/primitive/label/annotation';

import ZoneUsers from 'solis/logic/board/zone/users';


const getStatus = (zoneTimeline, currentDate) =>
{
  const winner = zoneTimeline.getWinner(currentDate);

  if (winner !== new ZoneUsers(zoneTimeline.getZone(currentDate)).getColonyUser())
  {
    return zoneTimeline.getControlWinner(currentDate) === winner ? 'occupied' : 'surrendered';
  }

  return zoneTimeline.isContested(currentDate) ? 'contested' : null;
};


export default ({ zoneTimeline, currentDate, required, mark }) =>
{
  const status = getStatus(zoneTimeline, currentDate) ?? (required ? 'stable' : null);

  return status ? <Annotation mark = {mark}>{status}</Annotation> : null;
};
